import axios from 'axios';
import get from 'lodash/get';

import * as Constants from '../../constants';
import { getValidationErrors } from '../../utils';
import { getConfig } from '../../reducers/portalConfig';

export const checkSession = async (state) => {
  const config = getConfig(state);
  const { portal } = config;
  return axios.get(`${portal.hostname}/admin/sessionCheck`, { credentials: 'include' })
    .then(res => get(res, 'data.status', ''))
    .catch(err => get(err, 'response.data.status', ''));
};

export const updateUserContexts = (data) =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/userContexts`;

    axios.put(url, data, { credentials: 'include' })
      .then(() => {
        dispatch({
          type: Constants.USER_CONTEXTS_UPDATE_SUCCESS,
          isLoading: false,
        });
        window.location.href = '/admin/app/dashboard';
      })
      .catch((error) => {
        dispatch({
          type: Constants.API_ERROR,
          isLoading: false,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchRequests = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Requests?$filter=RequestStatus eq 'PENDING'`;

    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_REQUESTS_SUCCESS,
          isLoading: false,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: Constants.FETCH_REQUESTS_ERROR,
          isLoading: false,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchAppSecretHashingMetadata = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Settings('APP_SECRET_HASHING_METADATA')`;

    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_APP_SECRET_HASHING_METADATA_SUCCESS,
          isLoading: false,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: Constants.FETCH_APP_SECRET_HASHING_METADATA_ERROR,
          isLoading: false,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchDeploymentRefreshTime = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Settings('DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS')`;

    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: Constants.FETCH_DEPLOYMENT_REFRESH_COUNTDOWN_IN_SECONDS_ERROR,
          payload: getValidationErrors(error),
        });
      });
  };

export const fetchApplicationRequestSetting = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Settings('APPLICATION_REQUEST_WORKFLOW')`;
    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_APPLICATION_REQUEST_SETTING_SUCCESS,
          payload: response.data,
        });
      })
      .catch(() => {});
  };

export const fetchApplicationEditRequestSetting = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Settings('EDIT_APPLICATION_REQUEST_WORKFLOW')`;
    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_APPLICATION_EDIT_REQUEST_SETTING_SUCCESS,
          payload: response.data,
        });
      })
      .catch(() => {});
  };

export const fetchLockUserCreation = () =>
  async (dispatch, getState) => {
    const config = getConfig(getState());
    const { portal } = config;
    const url = `${portal.hostname}/api/${portal.tenantPrefix}/Settings('LOCK_USER_CREATION')`;
    axios.get(url, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: Constants.FETCH_SETTING_USER_LOCK_CREATION_SUCCESS,
          payload: response.data,
        });
      })
      .catch(() => {});
  };



// WEBPACK FOOTER //
// ./src/actions/portalConfig/index.js